module.exports = __webpack_public_path__ + "media/images/our-story-inner-banner-c7b755469fc35f91220cef590075f901.webp";